import { render, staticRenderFns } from "./PoliticasMaxica.vue?vue&type=template&id=681b4ab9&scoped=true"
import script from "./PoliticasMaxica.vue?vue&type=script&lang=js"
export * from "./PoliticasMaxica.vue?vue&type=script&lang=js"
import style0 from "./PoliticasMaxica.vue?vue&type=style&index=0&id=681b4ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b4ab9",
  null
  
)

export default component.exports